import { assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestWorkspaceUserOwnershipTransferCreate extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_WORKSPACE_TRANSFER_OWNERSHIP_TRANSFER_CREATE;

  workspace_id!: string;
  workspace_user_id!: string;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_object_id(this.workspace_id);
    assert_string_object_id(this.workspace_user_id);
  }
}
